import * as yup from 'yup'

export const existingPodcastFormvalidationSchema = yup.object().shape({
  url: yup
    .string()
    .matches(/spotify\.com\/show\/(\w{22})/i, 'Please provide a correct Spotify podcast URL.')
    .required(),
})

export const newPodcastFormvalidationSchema = yup.object().shape({
  title: yup.string().required(),
  description: yup.string().required(),
  authorName: yup.string().required(),
  contactEmail: yup.string().email('Must be a valid email.').required(),
  artworkUrl: yup.string().required(),
  category: yup.string().required(),
})
